import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NavDropdownSharedComponent } from './nav.dropdown.component';
import { ClickOutsideSharedDirectiveModule } from '../../../shared/directive/click.outside/click.outside.module';

@NgModule({
    declarations: [
        NavDropdownSharedComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild([]),
        ClickOutsideSharedDirectiveModule
    ],
    exports: [
        NavDropdownSharedComponent
    ]
})

// tslint:disable-next-line:no-unnecessary-class
export class NavDropdownSharedModule {}
